<div class="modal__header">
  <div class="modal__title">
    Import a template
  </div>
  <div class="modal__close" (click)="popup.close();">
    <i class="fas fa-times"></i>
  </div>
</div>
<div class="modal__content">
  <div class="select-box">
    <select name="template_id" #templateId class="form-select" (change)="changeTemplate(templateId.value)">
      <option value="">Select a template</option>
      @for (template of templates; track template; let i = $index) {
        <option [value]="i">{{template.name}}</option>
      }
    </select>
  </div>
  <div class="items-title">
    Items in this template:
  </div>
  <div class="items-container">
    @for (operation of operations; track operation) {
      <div class="item">
        {{operation.name}}
      </div>
    }
    @for (operation of lockedOperations; track operation) {
      <div class="item">
        {{operation.name}}
      </div>
    }
  </div>
</div>
<div class="modal__footer">
  <button type="reset" class="btn btn-link" (click)="popup.close();">Cancel</button>
  <button type="submit" class="btn btn-primary" [disabled]="disableSaveButton"
    (click)="loadTemplateIntoSpreader()">Save
  </button>
</div>
